import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Gift, Flame, Sparkles } from 'lucide-react';
export function PurchaseSection() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 30,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          minutes,
          seconds
        } = prev;
        seconds -= 1;
        if (seconds < 0) {
          seconds = 59;
          minutes -= 1;
        }
        if (minutes < 0) {
          minutes = 0;
          seconds = 0;
        }
        return {
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <section id="comprar" className="py-14 sm:py-18 px-4 sm:px-6 lg:px-8 bg-deco-terra relative overflow-hidden scroll-mt-10" data-id="element-114">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-white/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-115"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-deco-sage-dark/20 rounded-full blur-3xl translate-y-1/3 -translate-x-1/3" data-id="element-116"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-white/5 rounded-full blur-3xl" data-id="element-117"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-119">
          {/* Urgency badge */}
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-5 py-2 rounded-full text-sm font-bold uppercase tracking-wider mb-8 border border-white/20" data-id="element-120">
            <Flame size={16} data-id="element-121" />
            Oferta por tiempo limitado
          </div>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight mb-6 text-white" data-id="element-122">
            Accedé hoy a la Mega Guía{' '}
            <span className="font-script text-4xl sm:text-5xl lg:text-6xl font-normal" data-id="element-123">
              Cemento & Yeso
            </span>{' '}
            Deco desde Cero
          </h2>

          {/* Countdown */}
          <div className="flex items-center justify-center gap-3 mb-10" data-id="element-124">
            <span className="text-white/80 font-semibold text-sm sm:text-base uppercase tracking-wider" data-id="element-125">
              Esta oferta termina en
            </span>
            <div className="flex items-center gap-1.5 font-mono text-lg sm:text-xl font-bold" data-id="element-126">
              <span className="bg-white text-deco-terra rounded-lg px-3 py-2 min-w-[48px] text-center shadow-lg" data-id="element-127">
                {pad(timeLeft.minutes)}
              </span>
              <span className="text-white text-2xl font-bold" data-id="element-128">:</span>
              <motion.span key={`ps-${timeLeft.seconds}`} initial={{
              scale: 1.1
            }} animate={{
              scale: 1
            }} transition={{
              duration: 0.15
            }} className="bg-white text-deco-terra rounded-lg px-3 py-2 min-w-[48px] text-center shadow-lg" data-id="element-129">
                {pad(timeLeft.seconds)}
              </motion.span>
            </div>
          </div>

          {/* Price card */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-white text-deco-text rounded-[2rem] sm:rounded-[3rem] p-8 sm:p-12 shadow-2xl max-w-xl mx-auto" data-id="element-130">
            <div className="inline-flex items-center gap-2 bg-deco-terra/10 text-deco-terra px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wider mb-8" data-id="element-131">
              <Gift size={16} data-id="element-132" />
              Bonos incluidos solo por hoy
            </div>

            <div className="flex flex-col items-center gap-2 mb-8" data-id="element-133">
              <span className="text-xl text-deco-muted line-through font-serif decoration-deco-terra/50 decoration-2" data-id="element-134">
                $39.990 ARS
              </span>
              <div className="flex items-baseline gap-2" data-id="element-135">
                <span className="text-6xl sm:text-7xl font-bold text-deco-text font-serif leading-none" data-id="element-136">
                  $19.990
                </span>
                <span className="text-2xl text-deco-taupe font-serif" data-id="element-137">ARS</span>
              </div>
            </div>

            <motion.a href="https://pago.atlasdigitalhub.com/cart/42849429618786:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} className="block w-full py-5 px-6 rounded-full bg-deco-terra text-white font-bold text-lg sm:text-xl uppercase tracking-wider hover:bg-deco-terra/90 transition-colors duration-300 shadow-xl hover:shadow-2xl text-center mb-6" data-id="element-138">
              QUIERO ACCEDER A LA MEGA GUÍA
            </motion.a>

            <div className="flex items-center justify-center gap-2 text-xs sm:text-sm text-deco-taupe font-medium" data-id="element-139">
              <ShieldCheck size={16} data-id="element-140" />
              <span data-id="element-141">Acceso inmediato · Producto digital · Pago seguro</span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}